import { render, staticRenderFns } from "./OrderDistributionPoint.vue?vue&type=template&id=7be36290"
import script from "./OrderDistributionPoint.vue?vue&type=script&lang=js"
export * from "./OrderDistributionPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports